import { cn } from '@/ui/utils';
import { mergeProps } from '@base-ui/react/merge-props';
import { useRender } from '@base-ui/react/use-render';
import { cva, VariantProps } from 'cva';

const card = cva({
  base: ['rounded-lg border bg-white shadow-xs'],
  variants: {
    variant: {
      default: [''],
    },
  },
});

interface Props extends useRender.ComponentProps<'div'>, VariantProps<typeof card> {}

export function Card(props: Props) {
  const { render = <div />, variant, className, ...otherProps } = props;

  return useRender({
    render,
    props: mergeProps<'div'>(
      {
        className: cn(card({ className, variant })),
      },
      otherProps,
    ),
  });
}
